import { render, staticRenderFns } from "./address-apartment.vue?vue&type=template&id=b6d9507c&scoped=true"
import script from "./address-apartment.vue?vue&type=script&lang=js"
export * from "./address-apartment.vue?vue&type=script&lang=js"
import style0 from "./address-apartment.vue?vue&type=style&index=0&id=b6d9507c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d9507c",
  null
  
)

export default component.exports